import { createContext } from 'react'

// State
export interface JobState {
  applicationOpen: boolean
  applicationSuccess: boolean
  backendErrors: string[]
  dummyState: boolean
}

export const initialJobState: JobState = {
  applicationOpen: false,
  applicationSuccess: false,
  backendErrors: [],
  dummyState: false,
}

// Actions
export enum ActionType {
  SetApplicationOpen,
  SetApplicationSuccess,
  SetBackendErrors,
  UpdateJobState,
}

export interface SetApplicationOpen {
  type: ActionType.SetApplicationOpen
  payload: boolean
}

export interface SetApplicationSuccess {
  type: ActionType.SetApplicationSuccess
  payload: boolean
}

export interface SetBackendErrors {
  type: ActionType.SetBackendErrors
  payload: string[]
}

export interface UpdateJobState {
  type: ActionType.UpdateJobState
  payload: boolean
}

export type JobActions =
  | SetApplicationOpen
  | SetApplicationSuccess
  | SetBackendErrors
  | UpdateJobState

// Reducer
export function jobReducer(state: JobState, action: JobActions): JobState {
  switch (action.type) {
    case ActionType.UpdateJobState:
      return { ...state, dummyState: action.payload }
    case ActionType.SetApplicationOpen:
      return { ...state, applicationOpen: action.payload }
    case ActionType.SetApplicationSuccess:
      return { ...state, applicationSuccess: action.payload }
    case ActionType.SetBackendErrors:
      return { ...state, backendErrors: action.payload }
    default:
      return state
  }
}

// Context
export const JobContext = createContext<{
  state: JobState
  dispatch: React.Dispatch<JobActions>
}>({
  state: initialJobState,
  dispatch: () => undefined,
})
